import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`

h4 {
  text-transform: uppercase;
}
  h3 {
    font-style: unset;
  }
  @media all and (max-width: 1024px) {
    h4 {
      font-size: 22px;
    }
   }
   @media all and (min-width: 993px) and (max-width: 1200px) {
       width: 50%;
margin-right: 1em;
   }

`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 20px 0 0 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width: ${props => props.width ? props.width : ''}; */
  overflow: hidden;

  h3, p {
    text-align: center;
  }

  p {
    font-size: 20px;
    color: #acff24;
    margin: 15px 0 10px 0;
    text-align: center;
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/SummaryInfo/SummaryInfo.styles.ts